<template>
  <v-dialog v-model="dialog" width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom v-bind="attrs" v-on="on">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-btn color="primary" text x-small v-on="on" @click="loadData">
              <v-icon small>mdi-currency-usd</v-icon>
            </v-btn>
          </span>
        </template>
        <span>Billing & Payment Details</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        Billing & Payment Details
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="invoices"
          hide-default-footer
          disable-pagination
          class="invoices"
          item-key="uniqueId"
        ></v-data-table>
      </v-card-text>
      <v-card-actions class="pa-5">
        <v-spacer></v-spacer>
        <v-subheader class="text-subtitle-1">
          Balance:
          <span class="font-weight-bold pl-2"> {{ balance }}</span>
        </v-subheader>
        <div class="text-caption">* excluding pending transactions</div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["sessionId", "balance"],
  data: function () {
    return {
      dialog: false,
      headers: [
        { text: "Invoice Id", value: "sessionInvoiceId" },
        { text: "Invoice Date", value: "formattedInvoiceDate" },
        { text: "Invoice Number", value: "formattedInvoiceNumber" },
        {
          text: "Billed Amount",
          value: "formattedBilledAmount",
          sortable: false,
        },
        { text: "Status", value: "status" },
        { text: "Payment", value: "formattedPaidAmount", sortable: false },
        {
          text: "Adjustment",
          value: "formattedAdjustmentAmount",
          sortable: false,
        },
        {
          text: "Adjustment Type",
          value: "formattedAdjustmentType",
          sortable: false,
        },
        { text: "Payment Date", value: "formattedPaymentDate" },
        { text: "Payer", value: "payer" },
        { text: "Check Number", value: "checkNumber" },
        { text: "Posted On", value: "formattedPostedAt" },
      ],
      invoices: [],
    };
  },
  methods: {
    async loadData() {
      this.$store.commit("uxModule/setShowLoader", true);
      this.invoices = await this.$store.dispatch(
        "billingModule/getSessionInvoicesWithPaymentDetails",
        this.sessionId
      );
      this.$store.commit("uxModule/setShowLoader", false);
      this.dialog = true;
    },
  },
};
</script>
<style>
.invoices td {
  font-size: 12px !important;
}
</style>
